import * as React from "react";
import { forwardRef } from "react";
const SvgMinus = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M26.666 16c0 .736-.597 1.333-1.333 1.333H6.667a1.333 1.333 0 0 1 0-2.666h18.666c.736 0 1.333.597 1.333 1.333Z" }));
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
